import { Arkiv } from './../../../models/arkiv';
import RequestService from '../requestService';
import { client } from '../../client';


export default class ArkivService extends RequestService<Arkiv, 'arkiv'>
{
    validateFraDato = async (value : Arkiv) => client.post<boolean>(`${this.serviceName}/ValidateFraDato`,value);
    validateTilDato = async (value : Arkiv) => client.post<boolean>(`${this.serviceName}/ValidateTilDato`,value);
}